import { Button, Card, Divider, Empty, Pagination, Spin } from "antd";
import moment from "moment/moment";
import React, { useEffect, useState } from "react";
import { FaClock } from "react-icons/fa6";
import { FaFilePdf } from "react-icons/fa";
import { get } from "../../apiService";
import { getProfile } from "../../services/localStorageServices";
import Excel from "../Export/Excel";
import Pdf from "../Export/Pdf";

export default function Orders() {
  const [orderList, setOrderList] = useState([]);
  const { profile } = getProfile();
  const [pagination, setPagination] = useState({
    page: 1,
    totla: 0,
    limit: 10,
  });
  const [loading, setLoading] = useState(false);

  const exportColumn = [
    { title: "Avg Weight", dataIndex: "avg_wt", key: "avg_wt" },
    { title: "Sieve", dataIndex: "sive_sizes", key: "sive_sizes" },
    { title: "Size (MM)", dataIndex: "diam_mm", key: "diam_mm" },
    { title: "Colour", dataIndex: "color", key: "color" },
    { title: "Shade", dataIndex: "shade", key: "shade" },
    { title: "Cut", dataIndex: "cut", key: "cut" },
    { title: "Clarity", dataIndex: "clarity", key: "clarity" },
    { title: "Price", dataIndex: "price", key: "price" },
    // { title: "Type", dataIndex: "typeSelect", key: "typeSelect" },
    // { title: "Selected Type", dataIndex: "updateCarat", key: "updateCarat" },
    { title: "Total Weight", dataIndex: "total_weight", key: "total_weight" },
    { title: "Value", dataIndex: "subtotal", key: "subtotal" },
  ];

  const columns = [
    { title: "Payment Type", dataIndex: "payment_type", key: "payment_type" },
    { title: "Order Status", dataIndex: "order_status", key: "order_status" },
    { title: "Subtotal", dataIndex: "sub_total", key: "sub_total" },
    {
      title: "Shipping",
      dataIndex: "shipping_charges",
      key: "shipping_charges",
    },
    { title: "Total", dataIndex: "total", key: "total" },
  ];

  const fetchOrder = async (page, limit) => {
    try {
      const user_id = profile?.user_id;
      setLoading(true);
      const resp = await get(
        `/orders.php?page=${page}&limit=${limit}&user_id=${user_id}&action=fetch`
      );

      if (resp) {
        setLoading(false);

        setOrderList(resp.list);
        setPagination((prev) => ({ ...prev, totla: resp.total }));
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  useEffect(() => {
    const dbounce = setTimeout(() => {
      fetchOrder(pagination.page, pagination.limit);
    }, 300);

    return () => clearTimeout(dbounce);
  }, [pagination.page, pagination.limit]);

  const statusClasses = {
    success: "text-success",
    pending: "text-warning",
    cancel: "text-danger",
  };

  const formatValue = (value, data) => {
    // Format specific fields as monetary values
    const monetaryFields = ["sub_total", "shipping_charges", "total"];
    if (monetaryFields.includes(value)) {
      return data[value] ? "$ " + data[value] : "";
    }
    return data[value];
  };

  const getClass = (value) => {
    // Return appropriate class based on status
    return statusClasses[value] || "";
  };

  return (
    <Spin spinning={loading}>
      <div className="row mb-5 pb-5">
        {orderList?.length > 0 ? (
          orderList.map((data, index) => (
            <div className="col-lg-6 mb-4">
              <Card key={index}>
                <div className="bookedDate d-flex align-items-center mb-3">
                  <FaClock />
                  &nbsp;&nbsp;{moment(data.created_at).format("llll")}
                </div>

                {columns.map((value, i) => (
                  <div className="row" key={i}>
                    <div className="col-6">
                      <strong>{value.title}</strong>
                    </div>
                    <div className="col-2">:</div>
                    <div
                      className="col-4 d-flex align-items-center justify-content-end"
                      style={{ textTransform: "capitalize" }}
                    >
                      {statusClasses[data[value.dataIndex]] ? (
                        <span className={getClass(data[value.dataIndex])}>
                          {data[value.dataIndex]}
                        </span>
                      ) : (
                        formatValue(value.dataIndex, data)
                      )}
                    </div>
                  </div>
                ))}
                <Divider />
                <div className="buttonGroup d-flex">
                  <Pdf
                    column={exportColumn}
                    comment={data.comment}
                    data={
                      data.products.length > 0
                        ? [
                            ...data.products,
                            {
                              price: "Total",
                              total_weight: data.total_weight,
                              subtotal: data.sub_total,
                            },
                            {
                              price: "Shipping",
                              total_weight: "",
                              subtotal: data.shipping_charges,
                            },
                            {
                              price: "Net Total",
                              total_weight: "",
                              subtotal: data.total,
                            },
                          ]
                        : []
                    }
                    fileName={profile.name + " " + data.created_at}
                  />
                  &nbsp;
                  <Excel
                    column={exportColumn}
                    comment={data.comment}
                    data={
                      data.products.length > 0
                        ? [
                            ...data.products?.sort((a, b) => a.avg_wt - b.avg_wt),
                            {
                              price: "Total",
                              total_weight: data.total_weight,
                              subtotal: data.sub_total,
                            },
                            {
                              price: "Shipping",
                              total_weight: "",
                              subtotal: data.shipping_charges,
                            },
                            {
                              price: "Net Total",
                              total_weight: "",
                              subtotal: data.total,
                            },
                          ]
                        : []
                    }
                    fileName={profile.name + " " + data.created_at}
                  />
                </div>
              </Card>
            </div>
          ))
        ) : (
          <Empty />
        )}
        <div className="col-12">
          <Pagination
            current={pagination.page}
            total={pagination.totla}
            onChange={(page) =>
              setPagination((prev) => ({ ...prev, page: page }))
            }
          />
        </div>
      </div>
    </Spin>
  );
}
